import { createContext } from 'react';

export type AutoBalanceTransferCtx = {
  showCancelAutoBalanceTransferConfirmAlert: boolean;
  showCancelAutoBalanceTransferErrorAlert: boolean;
  showCancelAutoBalanceTransferSuccessAlert: boolean;
  cancelAutoBalanceTransferError: string;
};

const AutoBalanceTransferContext = createContext<AutoBalanceTransferCtx>({
  showCancelAutoBalanceTransferConfirmAlert: false,
  showCancelAutoBalanceTransferErrorAlert: false,
  showCancelAutoBalanceTransferSuccessAlert: false,
  cancelAutoBalanceTransferError: '',
});

export default AutoBalanceTransferContext;